import { useExperiment } from '@xing-com/hub';

import { EXPERIMENTS } from '../../config/experiments';

export const useCompaniesExperiments = () => {
  const newLoggedOutExperiment = useExperiment(
    EXPERIMENTS.NEW_LOGGED_OUT_SCREEN.name
  );

  const isNewLoggedOutExperimentEnabled =
    newLoggedOutExperiment !== EXPERIMENTS.NEW_LOGGED_OUT_SCREEN.variants.A;

  return {
    isNewLoggedOutExperimentEnabled,
  };
};
